import React from 'react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito equipo especial?',
    a: 'Solo tus audífonos y un papel.'
  }, {
    q: '¿Es un curso largo?',
    a: 'No, es un protocolo práctico de 10 minutos por noche.'
  }, {
    q: '¿Funciona si tengo el sueño ligero?',
    a: 'Sí, el audio ayuda a estabilizar las ondas para un descanso más profundo.'
  }];
  return <section className="py-16 md:py-24 bg-navy-800/20" data-id="element-20">
      <div className="container mx-auto px-4" data-id="element-21">
        <div className="max-w-3xl mx-auto" data-id="element-22">
          <h2 className="text-3xl md:text-4xl text-center mb-12" data-id="element-23">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-24">
            {faqs.map((faq, index) => <div key={index} className="glass-panel p-6 md:p-8" data-id="element-25">
                <h3 className="text-xl text-white mb-3 font-medium" data-id="element-26">{faq.q}</h3>
                <p className="text-steel-400" data-id="element-27">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}